import { render } from "./CategoryElevenComponent.vue?vue&type=template&id=2a9b61dc&scoped=true"
import script from "./CategoryElevenComponent.vue?vue&type=script&lang=ts"
export * from "./CategoryElevenComponent.vue?vue&type=script&lang=ts"

import "./CategoryElevenComponent.vue?vue&type=style&index=0&id=2a9b61dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a9b61dc"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QCard,QCardSection,QForm,QSelect,QItem,QItemSection,QInput,QIcon,QTooltip});
